import { CategoryOption, TargetOption } from './rule-detail.types';

// Categories and their targets for the Add criteria modal
export const CATEGORY_OPTIONS: CategoryOption[] = [
  { value: 'users', label: 'Users' },
  { value: 'hashtags', label: 'Hashtags' },
  { value: 'locations', label: 'Locations' },
  { value: 'keywords', label: 'Keywords' },
];

export const TARGET_OPTIONS: Record<string, TargetOption[]> = {
  users: [
    { value: 'User (followers)', label: 'Followers of accounts', description: 'Target users who follow specific accounts' },
    { value: 'User (followings)', label: 'Followings of accounts', description: 'Target users followed by specific accounts' },
    { value: 'User Posts (likers)', label: 'Likers of posts from accounts', description: 'Target users who liked posts from specific accounts' },
    { value: 'User (specific user)', label: 'Specific users', description: 'Target specific individual users' },
  ],
  hashtags: [
    { value: '#Hashtags', label: 'Posts with hashtags', description: 'Target posts that use specific hashtags' },
    { value: '#Hashtags Posts (likers)', label: 'Likers of posts with hashtags', description: 'Target users who liked posts with specific hashtags' },
  ],
  locations: [
    { value: 'Places', label: 'Posts from locations', description: 'Target posts from specific locations' },
    { value: 'Places Posts (likers)', label: 'Likers of posts from locations', description: 'Target users who liked posts from specific locations' },
  ],
  keywords: [
    { value: 'Posts by Keyword', label: 'Posts containing keywords', description: 'Target posts containing specific keywords' },
    { value: 'Posts by Keyword (likers)', label: 'Likers of posts with keywords', description: 'Target users who liked posts with specific keywords' },
    { value: 'Reels by Keyword', label: 'Reels containing keywords', description: 'Target reels containing specific keywords' },
    { value: 'Reels by Keyword (likers)', label: 'Likers of reels with keywords', description: 'Target users who liked reels with specific keywords' },
  ],
};
